import React from 'react';
import PropTypes from 'prop-types';
import {
	Icon,
	Popup
} from 'semantic-ui-react';

import { log } from '../../../../../../services/utils';

const TemplateModuleInfoPopup = ( { description } ) => {
	return (
		<Popup
			flowing
			position="top center"
			positionFixed
			trigger={
				<Icon
					link
					name="info circle"
					size="large"
				/>
			}
		>
			{ log( '-templateModuleInfoPopup' ) }
			<Popup.Content>
				{ description }
			</Popup.Content>
		</Popup>
	);
};

TemplateModuleInfoPopup.propTypes = { description: PropTypes.string.isRequired };

export default TemplateModuleInfoPopup;
